import { EventEnums, RequestOptions, Response, EventTypes, EventFunctions } from '@altenar/models'
import Requests from '@altenar/transport'

export class GetTopSportsAndEvents {
  public isTopEventsLoading: boolean = false
  public selectedSport = {} as Response.TopSport
  private readonly topEventsType: EventEnums.TopEventsType
  private getTopEvents: Requests.GetTopEventsByType
  private getTopSports: Requests.GetTopSportsByType
  private events: EventTypes.Event[] = []

  constructor(topEventsType: EventEnums.TopEventsType) {
    this.topEventsType = topEventsType
    this.getTopEvents = new Requests.GetTopEventsByType(topEventsType)
    this.getTopSports = new Requests.GetTopSportsByType(topEventsType)
    this.getTopEvents.isLoading = loading => {
      this.isTopEventsLoading = !this.events.length && loading
    }
    this.getTopEvents.onSuccess = events => this.onEventsDataReceive(events)
    this.getTopSports.onSuccess = sports => this.onSportsDataReceive(sports)
  }

  public onTopEventsReceive(events: EventTypes.Event[]) {
    return
  }
  public onTopSportsReceive(sports: Response.TopSport[]) {
    return
  }

  public async fetchSports() {
    await this.getTopSports.fetchRequest()
  }

  public async fetchEventsBySport(requestOptions: RequestOptions.TopEventsRequestOptions) {
    await this.getTopEvents.fetchRequest(requestOptions)
  }

  public stop() {
    this.getTopEvents.stop()
    this.getTopSports.stop()
  }

  protected async onSportsDataReceive(sports: Response.TopSport[]) {
    if (sports.length) {
      if (this.selectedSport.SportId) {
        this.selectedSport = sports.filter(sport => sport.SportId === this.selectedSport.SportId)[0]
      } else {
        this.selectedSport = sports[0]
      }
      this.onTopSportsReceive(sports)
      await this.fetchEventsBySport({
        count: 10,
        showAllEvents: false,
        sportId: this.selectedSport.SportId
      })
    }
  }

  protected onEventsDataReceive(rawEvents: EventTypes.Event[]) {
    const events = EventFunctions.parseEvents(EventFunctions.extractEventsFromTree(rawEvents))
    const headers = EventFunctions.parseHeaders(EventFunctions.extractHeadersFromTree(rawEvents))
    this.events = EventFunctions.sortMarketsAccordingToHeader(events, headers)
    this.onTopEventsReceive(this.events)
  }

}
